import { DocumentWarning, STDocument } from '@st/sdk'

export function formatDocumentWarning(
  warning: DocumentWarning,
  opts?: { documentNameById?: Record<string, string> }
) {
  switch (warning.type) {
    case 'duplicate':
      const duplicateName = warning.documentId
        ? opts?.documentNameById?.[warning.documentId]
        : undefined
      return `⚠️ Duplicate of ${duplicateName ?? warning.documentId ?? 'document'}`
    case 'password_protected':
      return '⚠️ Document is password protected'
    case 'tax_year_mismatch':
      return `⚠️ Tax year mismatch. Expected ${warning.expectedYear}, but got ${warning.actualYear}`
  }
}

export function selDocumentNameById(documents: STDocument[]) {
  return Object.fromEntries(documents.map((doc) => [doc.id, doc.name]))
}
